import * as DocumentPicker from 'expo-document-picker/build';
import { call } from 'redux-saga/effects';

import Platform from '../../Platform';
import { ACCEPTED_FILE_MIME_TYPES } from '../constants';

export function* pickFile() {
  // Currently native package doesn't support list of mime types
  const isWeb = (Platform.OS !== 'ios' && Platform.OS !== 'android');
  const options = isWeb ? { type: ACCEPTED_FILE_MIME_TYPES.join(', ') } : {};

  const { assets, canceled } = yield call(DocumentPicker.getDocumentAsync, options);
  const { name, uri } = assets?.[0] ?? {};

  return { cancelled: canceled, name, uri };
}
